export default function Progressbar({ progress, progressColor }) {
    return (
        <div style={{ width: `100%`, height: '0.5rem', background: 'rgb(226 232 240)', borderRadius: '1rem',transition:'all 0.5s ease-in-out' }}>
            <div style={{ background: progressColor, height: "0.5rem", width: `${progress}%`, borderRadius: '1rem', zIndex: 2 }}></div>
        </div>
    )
}